import { GetRoiReq } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import dayjs from 'dayjs';
import { AnalyticsHooks } from '@frontend/analytics-shared';
import { RoiBaseFilters } from '../types';

export interface UseRoiRequestBaseProps {
  filters?: RoiBaseFilters;
  isEnabled?: boolean;
}

export interface UseRoiRequestProps extends UseRoiRequestBaseProps {
  additionalRequestPayload: Omit<GetRoiReq, 'endDate' | 'isMulti' | 'locationId' | 'orgId' | 'startDate'>;
  isDemoAccount?: boolean;
}

interface UseRoiRequestPayload {
  request: GetRoiReq;
  skipRequest?: boolean;
}

export const useRoiRequestPayload = ({
  additionalRequestPayload,
  filters,
  isDemoAccount,
  isEnabled = true,
}: UseRoiRequestProps): UseRoiRequestPayload => {
  const { isMulti, orgId } = AnalyticsHooks.useIsMulti();

  const skipRequest =
    !isEnabled ||
    isDemoAccount ||
    typeof isDemoAccount === 'undefined' ||
    !filters?.locationIds?.length ||
    !filters?.startDate ||
    !filters?.endDate ||
    !orgId;

  return {
    request: {
      ...additionalRequestPayload,
      endDate: filters?.endDate ? `${dayjs(filters?.endDate).format('YYYY-MM-DD')}T23:59:59.999` : '',
      isMulti,
      locationId: filters?.locationIds,
      orgId,
      startDate: filters?.startDate ? `${dayjs(filters?.startDate).format('YYYY-MM-DD')}T00:00:00.000` : '',
    },
    skipRequest,
  };
};
